import { render } from "./TopicDetail.vue?vue&type=template&id=fb95a27e&scoped=true&ts=true"
import script from "./TopicDetail.vue?vue&type=script&lang=ts"
export * from "./TopicDetail.vue?vue&type=script&lang=ts"

import "./TopicDetail.vue?vue&type=style&index=0&id=fb95a27e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb95a27e"]])

export default __exports__